import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setBookingsList } from "src/reducers/bookings";
import { dummyBookings } from "src/constants/dummyBookings";

// ✅ GET BOOKINGS
export const getBookingsListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(
        `/api/v1/admin/bookings?${query}`
      );

      const apiResponse = res?.data;

      if (
        !apiResponse?.success ||
        !apiResponse?.data ||
        !apiResponse?.data?.data
      ) {
        dispatch(setBookingsList(dummyBookings));
        return dummyBookings;
      }

      const formattedData = {
        data: apiResponse.data.data.map((item: any) => ({
          id: item.id,

          parentName: item.parent?.fullName,
          parentPhone: item.parent?.phone,

          childName: item.child?.fullName,
          grade: item.child?.grade,
          emergencyName: item.child?.emergencyContactName,
          emergencyPhone: item.child?.emergencyContactPhone,

          // ✅ ADDRESS
          address: item.address?.fullAddress,
          addressLat: item.address?.latitude,
          addressLng: item.address?.longitude,

          // ✅ SCHOOL
          schoolName: item.school?.name,
          schoolLat: item.school?.latitude,
          schoolLng: item.school?.longitude,

          // ✅ NEW FIELDS
          tenure: item.tenure || "-",
          startDate: item.startDate
            ? new Date(item.startDate).toLocaleDateString()
            : "-",

          // ✅ CAPTAIN
          driverId: item.captain?.id || "",
          captainName: item.captain?.fullName,
          phone: item.captain?.phone,

          // ✅ ELIGIBLE CAPTAINS
          eligibleCaptains: item.eligibleCaptains || [],

          // ✅ STATUS
          status:
            item.status === 1
              ? "Assigned"
              : item.status === 2
              ? "Completed"
              : "Pending",
        })),
        total: apiResponse.data.total,
      };

      dispatch(setBookingsList(formattedData));
      return formattedData;
    } catch (err) {
      dispatch(setBookingsList(dummyBookings));
      return dummyBookings;
    }
  };

// ✅ ASSIGN CAPTAIN
export const assignDriverAction: any =
  ({ bookingId, captainId }) =>
  async () => {
    try {
      if (!bookingId || !captainId) {
        throw new Error("Invalid bookingId or captainId");
      }

      const res = await instance.put(
        `/api/v1/admin/bookings/${bookingId}/assign-captain?captainId=${captainId}`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };